import React from 'react';
import {getTrackBackground} from "react-range";
import {Range as ReactRange} from "react-range";

const Range = (props) => {
    const {
        value       = 0,
        thumb       = '|',
        onChange    = (value) => {},
        disabled    = false,
        step        = 1000,
        min         = 1000,
        max         = 1500000
    } = props;

    const handleChange = (values) => {
        onChange(!!values && values.length > 0 ? values[0] : 0);
    }

    return (
        <ReactRange
            values={[value]}
            step={step}
            min={min}
            max={max}
            onChange={(values) => handleChange(values)}
            disabled={disabled}
            renderTrack={({props, children}) => (
                <div onMouseDown={props.onMouseDown}
                     onTouchStart={props.onTouchStart}
                     className={'range-track-outer'}
                     style={{...props.style}}
                >
                    <div
                        ref={props.ref}
                        className={'range-track-inner'}
                        style={{
                            background: getTrackBackground({
                                values: [value],
                                colors: ["#009BF5", "#ACACAC"],
                                min: min,
                                max: max
                            }),
                        }}
                    >
                        {children}
                    </div>
                </div>
            )}
            renderThumb={({ props, isDragged }) => (
                <div
                    {...props}
                    className={'range-thumb-outer'}
                    style={{...props.style}}
                >
                    <div className={'range-thumb-inner'}>
                        {thumb}
                    </div>
                </div>
            )}
        />
    );
}

export default Range;
